import { gql } from '@apollo/client';

export default gql`
  mutation printCustomerPresentTicket($bookingReference: String!, $cashRegisterId: String!, $terminalId: String!, $itemRefs: [String]) {
    printCustomerPresentTicket(
      bookingReference: $bookingReference
      cashRegisterId: $cashRegisterId
      terminalId: $terminalId
      itemRefs: $itemRefs
    )
  }
`;
